// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./assets/stylesheets/components/buttons.scss
// module id = 424
// module chunks = 0